{
  "name": "@michelin/machinetk",
  "version": "7.0.0",
  "release": "25/03/2026",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration dev",
    "start-ssl": "ng serve --ssl --configuration dev",
    "build": "ng build --configuration production",
    "test": "ng test --watch=false --code-coverage",
    "lint": "ng lint --fix",
    "build-compress-indus": "ng build --configuration indus && gzipper c ./dist --include js,css,html --output-file-format [filename].[ext] ./dist-compressed/",
    "build-compress-prod": "ng build --configuration production && gzipper c ./dist --include js,css,html --output-file-format [filename].[ext] ./dist-compressed/"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.19",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.19",
    "@angular/compiler": "^21.2.19",
    "@angular/core": "^21.2.19",
    "@angular/forms": "^21.2.19",
    "@angular/material": "^21.2.14",
    "@angular/material-moment-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.2.19",
    "@angular/platform-browser-dynamic": "^21.2.19",
    "@angular/router": "^21.2.19",
    "@michelin/around-tire": "^10.4.0",
    "@michelin/auth": "^7.0.0",
    "@michelin/charts": "^10.4.0",
    "@michelin/maps": "^10.4.0",
    "@michelin/observability": "^1.1.3",
    "@michelin/theme": "^10.4.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "hammerjs": "^2.0.8",
    "install": "^0.13.0",
    "jwt-decode": "^4.0.0",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.48",
    "overlayscrollbars": "^2.12.0",
    "rxjs": "^7.5.5",
    "tslib": "^2.6.2",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.19",
    "@angular-eslint/builder": "^19.8.1",
    "@angular-eslint/eslint-plugin": "^19.8.1",
    "@angular-eslint/eslint-plugin-template": "^19.8.1",
    "@angular-eslint/schematics": "^19.8.1",
    "@angular-eslint/template-parser": "^19.8.1",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.19",
    "@types/jasmine": "^3.6.11",
    "@types/jasminewd2": "^2.0.10",
    "@types/jwt-decode": "^3.1.0",
    "@types/moment-timezone": "^0.5.30",
    "@types/node": "~18.11.18",
    "@types/overlayscrollbars": "^1.12.5",
    "@typescript-eslint/eslint-plugin": "^6.10.0",
    "@typescript-eslint/parser": "^6.10.0",
    "browserslist": "^4.20.2",
    "eslint": "^8.53.0",
    "eslint-config-prettier": "^8.5.0",
    "eslint-plugin-import": "^2.26.0",
    "eslint-plugin-jsdoc": "^48.2.12",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^4.2.1",
    "husky": "^7.0.4",
    "jasmine-core": "~4.2.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.4.1",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "postcss": "^8.4.12",
    "prettier": "^2.8.3",
    "prettier-eslint": "^15.0.1",
    "pretty-quick": "^3.1.3",
    "ts-node": "~10.5.0",
    "typescript": "^5.9.3"
  }
}
